import styled, { css } from "styled-components";

export const SearchContainer = styled.div`
  .bn-search__autocomplete-container {
    display: flex;
    position: unset;
    inset: unset;
    width: auto;
    max-width: 100%;
    margin: 0 auto;

    @media (min-width: 650px) {
      max-width: 60vw;
    }
  }

  ${({ customCss }) => css`
    ${customCss}
  `}
`;
